import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum InstantMessagingHeaderRightRegistryComponentId {
    InstantMessagingHeaderComposite = 0
}

interface IInstantMessagingHeaderRightRegistryProps {}

class InstantMessagingHeaderRightRegistry extends BaseComponentRegistry<InstantMessagingHeaderRightRegistryComponentId, IInstantMessagingHeaderRightRegistryProps> {}

const InstantMessagingHeaderRightRegistryView = createRegistryListView(
    () => InstantMessagingHeaderRightRegistry.getInstance()
);

export {
    IInstantMessagingHeaderRightRegistryProps,
    InstantMessagingHeaderRightRegistry,
    InstantMessagingHeaderRightRegistryComponentId,
    InstantMessagingHeaderRightRegistryView
};
